import { FastQuestionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';

export const employeeProfileChatFastQuestionsManagerTranslation: FastQuestionTranslation = {
  fastQuestionButtons: {
    question1: 'Feedback',
    question10: 'Szkolenia EduAkcja',
    question2: 'Dopasuj projekty',
    question3: 'Kluczowe kompetencje',
    question4: 'Awans',
    question5: 'Delegowanie zadań',
    question6: 'Polecane książki',
    question7: 'Motywacja',
    question8: 'Rozwiązywanie konfliktów',
    question9: 'Szkolenia otwarte',
  },
  fastQuestionTexts: {
    question1: 'W jaki sposób udzielić informacji zwrotnej pracownikowi?',
    question10: 'Jakie szkolenia EduAkcja polecasz dla mojego pracownika?',
    question2: 'W jakich typach projektów pracownik mógłby najlepiej się sprawdzić?',
    question3: 'Jakie kompetencje są kluczowe dla rozwoju na obecnym stanowisku pracownika?',
    question4:
      'Jakie kompetencje musi rozwijać mój pracownik by awansować w strukturze o jeden poziom?',
    question5:
      'Jak efektywnie delegować zadania, które pomogą pracownikowi rozwijać potrzebne kompetencje?',
    question6:
      'Jakie książki mogę polecić pracownikowi, które wspierają jego zawodowy plan rozwoju?',
    question7: 'Jak zmotywować pracownika do pracy nad swoim rozwojem?',
    question8: 'Jak mogę rozwiązać konflikt w zespole, w który zaangażowany jest pracownik?',
    question9: 'Jakie szkolenia otwarte polecasz dla mojego pracownika?',
  },
};
